import { render } from "./IssueRaisedIcon.vue?vue&type=template&id=46fbf5f1"
import script from "./IssueRaisedIcon.vue?vue&type=script&lang=js"
export * from "./IssueRaisedIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__